var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-login"},[_c('button',{staticClass:"wechat-btn",on:{"click":_vm.handleWechatLogin}},[_c('span',{staticClass:"wechat-icon"},[_vm._v("💚")]),_c('span',[_vm._v("微信一键登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }